import MuiTableBody from '@mui/material/TableBody';
import type { ReactNode } from 'react';

export interface TableBodyProps {
  children: ReactNode;
}

// Body section of a Table behind the facade.
export function TableBody({ children }: TableBodyProps) {
  return <MuiTableBody>{children}</MuiTableBody>;
}
